import { render, staticRenderFns } from "./ListTypePurpose.vue?vue&type=template&id=e031ec66&scoped=true"
import script from "./ListTypePurpose.vue?vue&type=script&lang=js"
export * from "./ListTypePurpose.vue?vue&type=script&lang=js"
import style0 from "./ListTypePurpose.vue?vue&type=style&index=0&id=e031ec66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e031ec66",
  null
  
)

export default component.exports